import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import TaskList from '../../modules/admin/components/TaskList';

interface TaskListType {
  isRequesterFlow?: boolean;
}

const RequestTaskList = ({ isRequesterFlow = false }: TaskListType) => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader
        title={isRequesterFlow ? t('admin->>TaskList.MyRequests') : t('admin->>TaskList.MyTasks')}
      />

      <TaskList isRequest={isRequesterFlow} />
    </>
  );
};

export default RequestTaskList;
